import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { NoFlyZoneService } from '../../state-services/noflyzone.service';
import {
  createNoFlyZoneAssets,
  creatingNoFlyZoneAssetsError,
  creatingNoFlyZoneAssetsSuccess,
  editNoFlyZone,
  editNoFlyZoneError,
  editNoFlyZoneSuccess,
  loadingNoFlyZoneAssets,
  loadingNoFlyZoneAssetsError,
  loadingNoFlyZoneAssetsSuccess,
} from './noflyzone.actions';

@Injectable()
export class NoFlyZoneEffects {
  loadingNoFlyZoneAssets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadingNoFlyZoneAssets),
      exhaustMap(() =>
        this.noFlyZoneService.getNoFlyZones().pipe(
          map((nfz) => loadingNoFlyZoneAssetsSuccess({ noFlyZones: nfz })),
          catchError((error) =>
            of(loadingNoFlyZoneAssetsError({ error: error })),
          ),
        ),
      ),
    ),
  );

  createNoFlyZoneAsset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createNoFlyZoneAssets),
      mergeMap(({ noFlyZone }) =>
        this.noFlyZoneService.createNoFlyZone(noFlyZone).pipe(
          map((response) => {
            return creatingNoFlyZoneAssetsSuccess({ noFlyZone: response });
          }),
          catchError((error) => of(creatingNoFlyZoneAssetsError({ error }))),
        ),
      ),
    ),
  );

  editNoFlyZoneAsset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editNoFlyZone),
      mergeMap(({ id, changes }) =>
        this.noFlyZoneService.editNoFlyZone(id, changes).pipe(
          map((response) => {
            return editNoFlyZoneSuccess({ noFlyZone: response });
          }),
          catchError((error) => {
            return of(editNoFlyZoneError({ error }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private noFlyZoneService: NoFlyZoneService,
  ) {}
}
